<script setup lang="ts">
import { useCmsBlock } from "#imports";
import type { Schemas } from "#shopware";

type CmsBlockShopStudioRecipesRecipeListing = Schemas["CmsBlock"] & {
  type: "shop-studio-recipes-recipe-listing";
  slot: string;
};

const props = defineProps<{
  content: CmsBlockShopStudioRecipesRecipeListing;
}>();

const { getSlotContent } = useCmsBlock(props.content);
const slotContent = getSlotContent("content");
</script>

<template>
  <div class="cms-text-block !m-0">
    <CmsGenericElement :content="slotContent" />
  </div>
</template>
